import { Link } from "react-router-dom"

import {hvnUriRoot, shopInfo, linkNavs, areaName } from "../core/defines";
import { NavLinkMaker, telBlockPc } from "../core/core"

function reserveBtn(hvnId){

    let id =""
    let linkTxt = "ネット予約"
    if(hvnId){
        id= `?girl_id=${hvnId}`
        linkTxt= "このキャストを予約"
    }

    return(
        <nav id="btn-reserve" className="btn-fix reserve">
            <a href={`${hvnUriRoot}/A6ShopReservation/${id}`} id="book_10" target="_blank" rel="noreferrer noopener">{linkTxt}</a>
        </nav>
    )
}
function telBtn(tel){

    return(
        <nav id="btn-reserve" className="btn-fix tel">
            <a id="tel_10" className="btn-tel" href={"tel:"+ tel }>電話予約</a>
        </nav>
    )
}


function Footer({hvnId=null}){

    return(
        <footer className="txt-center">
            <section>
                {/*
                <a href="https://www.cityheaven.net/tochigi/A0901/A090101/tulipgirls/reviews/?of=y" id="banner_2" target="_blank" rel="noreferrer noopener">
                    <img className="sp" src="/img/v-main.webp" alt="口コミ"/>
                </a>
                */}
                <span>
                    <a href="/home">
                        <img className="logo" src="/img/logo-utsunomiya.svg" alt="logo"/>
                    </a>
                </span>
                <nav className="pc box">
                    <ul className="navs">
                        {linkNavs.map((el)=>{
                            return(
                                <li key={el.name}>
                                    <NavLinkMaker data={el}>
                                        {el.name}
                                    </NavLinkMaker>
                                </li>
                            )
                        })}
                    </ul>
                </nav>
                <div>
                    {telBlockPc()}
                </div>
                <p className="subtitle">{ areaName }のソープランド 【{ shopInfo.name }】</p>
                <span className="copy">Copyright&copy;{ shopInfo.name } All Rights Reserved.</span>
            </section>
            <div id="btn-fix-parent">
                {telBtn(shopInfo.tel)}
                {reserveBtn(hvnId)}
            </div>
        </footer>
    );
}
export default Footer;